import { mtc } from '@/styles'
import { ReactNode } from 'react'

export enum DropdownType {
  dropdown,
}

export const InsightsDividedCard = ({
  columns,
  type,
}: {
  columns: Array<{
    content: ReactNode
    isLastColumn?: boolean
  }>
  type?: DropdownType
}) => (
  <div className="flex flex-row w-full sm:w-auto gap-2">
    {columns.map((config, index) => (
      <div
        className={mtc(
          type === DropdownType.dropdown ? 'p-0' : 'p-3',
          index > 0 ? 'border-neutral-200 flex-1 sm:flex-none' : '',
          'bg-neutral-100'
        )}
        key={index}
      >
        {config.content}
      </div>
    ))}
  </div>
)
